let audioCtx: AudioContext | null = null;
let lastPlayedAt = 0;

const DEBOUNCE_MS = 2000;

export const playNotificationSound = () => {
  const now = Date.now();
  if (now - lastPlayedAt < DEBOUNCE_MS) {
    return;
  }
  lastPlayedAt = now;
  try {
    if (!audioCtx || audioCtx.state === 'closed') {
      audioCtx = new AudioContext();
    }
    if (audioCtx.state === 'suspended') {
      // The surrounding try/catch cannot see this one: resume() rejects asynchronously, so a
      // bare `void` leaves an unhandled rejection. iOS Safari refuses it with
      // `InvalidStateError: Failed to start the audio device` whenever the audio session is
      // unavailable — silent switch on, another app holding the mic — and a chat notification
      // that simply stays quiet was landing in Sentry as an uncaught error.
      audioCtx.resume().catch(() => undefined);
    }

    const now = audioCtx.currentTime;

    // Note 1 — E5
    const osc1 = audioCtx.createOscillator();
    const gain1 = audioCtx.createGain();
    osc1.connect(gain1);
    gain1.connect(audioCtx.destination);
    osc1.type = 'sine';
    osc1.frequency.value = 659.25;
    gain1.gain.setValueAtTime(0.12, now);
    gain1.gain.exponentialRampToValueAtTime(0.001, now + 0.08);
    osc1.start(now);
    osc1.stop(now + 0.08);

    // Note 2 — A5
    const osc2 = audioCtx.createOscillator();
    const gain2 = audioCtx.createGain();
    osc2.connect(gain2);
    gain2.connect(audioCtx.destination);
    osc2.type = 'sine';
    osc2.frequency.value = 880;
    gain2.gain.setValueAtTime(0.12, now + 0.08);
    gain2.gain.exponentialRampToValueAtTime(0.001, now + 0.2);
    osc2.start(now + 0.08);
    osc2.stop(now + 0.2);
  } catch {
    // Audio not available
  }
};
